import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore.js";


import { PrimaryButton } from "../../components/button";
import { LoginLayout } from "../../components/layout";
import { CheckBox } from "../../components/checkbox";
import { TextInput } from "../../components/inputbox";

import images from "../../assets";
import styles from "./styles";

const Login = () => {
  const navigate = useNavigate();
  const signIn = useAuthStore((state) => state.signIn);
  const isLoading = useAuthStore((state) => state.isLoading);

  const [isPassword, setIsPassword] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!email || !password) {
      setError("Both email and password are required");
    } else if (
      email !== "admin@noblemarriage.com" &&
      password !== "NobleMarriage@Admin0987"
    ) {
      setError("Invalid email or password");
    } else {
      setError("");
      const payload = {
        username: email,
        password,
      };
      signIn(payload);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <LoginLayout>
      <div className="w-[300px] lg:w-[450px]">
        <div className="mb-[24px]">
          <div className={styles.topBigText}>Admin Login</div>
        </div>
        <div>
          <div className={styles.inputFieldContainer}>
            <div>
              <TextInput
                className={`${styles.inputStyle}`}
                type="email"
                id="email"
                placeholder="Your email address"
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="relative">
              <div>
                <TextInput
                  className={`${styles.inputStyle}`}
                  type={isPassword ? "password" : "text"}
                  id="pass"
                  placeholder="Enter your password"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <img
                  src={isPassword ? images.eyeIconViolet : images.eyeOffIcon}
                  className={styles.eyeIcon}
                  onClick={() => setIsPassword(!isPassword)}
                  alt="see"
                />
              </div>
            </div>
          </div>
          <div className="text-xs mt-4 mb-4 flex flex-row items-center justify-between font-mons-light space-x-2">
            <CheckBox
              type="checkbox"
              className="h-5 w-5 hidden lg:block"
              onChange={() => setRememberMe(!rememberMe)}
            >
              <span className="text-neutral-800 text-base font-normal font-Poppins leading-normal hidden lg:block">
                &nbsp;Remember Me
              </span>
            </CheckBox>

            <div className="justify-center items-center gap-2.5 inline-flex">
              <div
                onClick={() => navigate("/forgot-password")}
                className="text-pink-700 text-base font-semibold underline cursor-pointer"
              >
                Forgot your password?
              </div>
            </div>
          </div>

          {error && (
            <div className="text-pink-700 text-base font-normal text-center">
              {error}
            </div>
          )}
          <PrimaryButton
            text={"Login"}
            onClick={handleSubmit}
            loading={isLoading}
          />
        </div>
      </div>
    </LoginLayout>
  );
};

export default Login;








